module.exports = __webpack_public_path__ + "img/img_sub_ser_transformation_06.30f88e08.svg";